/**
 * /app/$tenantSlug/settings/analytics — old home of the HR analytics
 * dashboard. The page moved to Reports (persona round 2026-10: a report
 * is not a setting); this route only redirects so bookmarks and old links
 * keep working.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/settings/analytics",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/app/$tenantSlug/reports/analytics",
      params: { tenantSlug: params.tenantSlug },
      replace: true,
    });
  },
});
